/* eslint-disbale */

import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeCtxProvider } from './Provider/ThemeContextProvider'
import { BrowserRouter } from 'react-router-dom'
import { PostHogProvider } from 'posthog-js/react'
import env from './env/env'

import App from './App'
import './stylesheet.scss'
import './styles.css'
// import { ErrorBoundary } from './Components/ErrorBoundary'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <BrowserRouter>
    <ThemeCtxProvider>
      <PostHogProvider
        apiKey={env.POSTHOG_KEY}
        options={{
          api_host: env.POSTHOG_HOST,
          capture_exceptions: true,
          debug: process.env.NODE_ENV === 'development',
          autocapture: true,
          capture_pageview: false,
          disable_external_dependency_loading: false,
        }}
      >
        {/* <ErrorBoundary> */}
        <App />
        {/* </ErrorBoundary> */}
      </PostHogProvider>
    </ThemeCtxProvider>
  </BrowserRouter>,
)
